import {
  ProposalMove,
  ProposalOutcome,
  ProposalStage,
} from "work/proposals/__constants/proposal-lifecycle";
import z from "zod";

const count = z.number().int().nonnegative();

/**
 * Every count the proposal list shows, from `GET /work/proposals/counts` (#6709).
 *
 * `open` is the Proposals tab's badge, which does not move with the chips. Each chip group is keyed
 * by the values the list's own parameters take, and a chip's count is what the list shows with that
 * chip chosen in place of its group's selection.
 */
export const ProposalListCountsJSONZ = z.object({
  total: count,
  open: count,
  stages: z.record(z.enum(ProposalStage), count),
  moves: z.record(z.enum(ProposalMove), count),
  outcomes: z.record(z.enum(ProposalOutcome), count),
});

export type ProposalListCounts = z.infer<typeof ProposalListCountsJSONZ>;
